(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rv-home-editorial"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-rv-home-editorial]').forEach((section) => {
    if (section.dataset.motionReady === 'true') return;
    section.dataset.motionReady = 'true';
    const button = section.querySelector('[data-rv-film-toggle]');
    const videos = Array.from(section.querySelectorAll('.rvhe-film__video'));
    if (!button || !videos.length) {
      if (button) button.hidden = true;
      return;
    }
    const setState = (paused) => {
      button.dataset.paused = paused ? 'true' : 'false';
      const label = paused ? button.dataset.playLabel : button.dataset.pauseLabel;
      button.setAttribute('aria-label', label);
      const text = button.querySelector('.rvhe-motion__text');
      if (text) text.textContent = label;
    };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      videos.forEach((video) => video.pause());
      setState(true);
    }
    button.addEventListener('click', () => {
      const isPlaying = videos.some((video) => !video.paused);
      if (isPlaying) {
        videos.forEach((video) => video.pause());
        setState(true);
      } else {
        videos.forEach((video) => video.play().catch(() => {}));
        setState(false);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rv-home-intro"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-rv-home-intro]').forEach((section) => {
    if (section.dataset.motionReady === 'true') return;
    section.dataset.motionReady = 'true';
    const button = section.querySelector('[data-rv-motion-toggle]');
    const videos = Array.from(section.querySelectorAll('.rvhi-hero__video'));
    if (!button || !videos.length) {
      if (button) button.hidden = true;
      return;
    }
    const setState = (paused) => {
      button.dataset.paused = paused ? 'true' : 'false';
      const label = paused ? button.dataset.playLabel : button.dataset.pauseLabel;
      button.setAttribute('aria-label', label);
      const text = button.querySelector('.rvhi-motion__text');
      if (text) text.textContent = label;
    };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      videos.forEach((video) => video.pause());
      setState(true);
    }
    button.addEventListener('click', () => {
      const isPlaying = videos.some((video) => !video.paused);
      if (isPlaying) {
        videos.forEach((video) => video.pause());
        setState(true);
      } else {
        videos.forEach((video) => video.play().catch(() => {}));
        setState(false);
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
